// 增强版打印类
/* eslint-disable */
const Print = function (dom, options) {
  if (!(this instanceof Print)) return new Print(dom, options);

  this.options = this.extend({
    'noPrint': '.no-print',
    'landscape': false,
    'pageSize': 'A4',
    'margin': '0',
    'header': null,
    'footer': null,
    'customStyle': '',
    'showPrintDialog': true // 是否显示打印对话框
  }, options);

  if ((typeof dom) === "string") {
    this.dom = document.querySelector(dom);
  } else {
    this.isDOM(dom)
    this.dom = this.isDOM(dom) ? dom : dom.$el;
  }

  this.init();
};
Print.prototype = {
  init: function () {
    var content = this.getStyle() + this.getHtml();
    this.writeIframe(content);
  },
  extend: function (obj, obj2) {
    for (var k in obj2) {
      obj[k] = obj2[k];
    }
    return obj;
  },

  getStyle: function () {
    var str = "",
      styles = document.querySelectorAll('style,link');

    for (var i = 0; i < styles.length; i++) {
      str += styles[i].outerHTML;
    }
    
    // 隐藏不需要打印的元素
    str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>";
    
    // 打印方向配置
    var orientation = this.options.landscape ? 'landscape' : 'portrait';
    str += "<style>@page { size: " + this.options.pageSize + " " + orientation + "; margin: " + this.options.margin + "; }</style>";
    
    // 基础打印样式
    str += "<style>@media print { " +
           "body { margin: 0; padding: 0;} " +
           "html, body { width: 100% !important; height: 100% !important; } " +
           ".print-page { page-break-after: always; } " +
           "}</style>";
    
    // 自定义样式
    if (this.options.customStyle) {
      str += "<style>" + this.options.customStyle + "</style>";
    }
    
    return str;
  },

  getHtml: function () {
    // 保存原始表单状态
    this.saveFormState();
    
    // 添加页眉页脚
    var html = '';
    if (this.options.header) {
      html += '<div class="print-header">' + this.options.header + '</div>';
    }
    
    html += this.dom.outerHTML;
    
    if (this.options.footer) {
      html += '<div class="print-footer">' + this.options.footer + '</div>';
    }
    
    return html;
  },

  saveFormState: function() {
    var inputs = document.querySelectorAll('input');
    var textareas = document.querySelectorAll('textarea');
    var selects = document.querySelectorAll('select');

    // 保存 input 状态
    for (var k = 0; k < inputs.length; k++) {
      if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
        if (inputs[k].checked == true) {
          inputs[k].setAttribute('checked', "checked")
        } else {
          inputs[k].removeAttribute('checked')
        }
      } else if (inputs[k].type == "text") {
        inputs[k].setAttribute('value', inputs[k].value)
      } else {
        inputs[k].setAttribute('value', inputs[k].value)
      }
    }

    // 保存 textarea 状态
    for (var k2 = 0; k2 < textareas.length; k2++) {
      if (textareas[k2].type == 'textarea') {
        textareas[k2].innerHTML = textareas[k2].value
      }
    }

    // 保存 select 状态
    for (var k3 = 0; k3 < selects.length; k3++) {
      if (selects[k3].type == 'select-one') {
        var child = selects[k3].children;
        for (var i in child) {
          if (child[i].tagName == 'OPTION') {
            if (child[i].selected == true) {
              child[i].setAttribute('selected', "selected")
            } else {
              child[i].removeAttribute('selected')
            }
          }
        }
      }
    }
  },

  writeIframe: function (content) {
    var w, doc, iframe = document.createElement('iframe'),
      f = document.body.appendChild(iframe);
    iframe.id = "myIframe";
    iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
    w = f.contentWindow || f.contentDocument;
    doc = f.contentDocument || f.contentWindow.document;
    doc.open();
    doc.write('<!DOCTYPE html><html><head><title>打印</title></head><body>' + content + '</body></html>');
    doc.close();
    var _this = this
    iframe.onload = function(){
      _this.toPrint(w);
      setTimeout(function () {
        document.body.removeChild(iframe)
      }, 100)
    }
  },

  toPrint: function (frameWindow) {
    try {
      setTimeout(function () {
        frameWindow.focus();
        try {
          if (!frameWindow.document.execCommand('print', false, null)) {
            frameWindow.print();
          }
        } catch (e) {
          frameWindow.print();
        }
        frameWindow.close();
      }, this.options.showPrintDialog ? 100 : 10); // 延迟确保样式加载
    } catch (err) {
      console.log('err', err);
    }
  },
  isDOM: (typeof HTMLElement === 'object') ?
    function (obj) {
      return obj instanceof HTMLElement;
    } :
    function (obj) {
      return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
    }
};

const MyPlugin1 = {}
MyPlugin1.install = function (Vue, options) {
  Vue.prototype.$print1 = Print
}
export default MyPlugin1